

export default function TitleOnFilter({title}){
    return(
        <p className="text-c18 7:text-c22 font-bold text-black222 text-left">{title}</p>
    )
}